'use strict';

const unitConversion = function () {
    $(document).on('click', '.unit-toggle .toggle-conversion-btn', function () {
        const $this = $(this);
        const selectedUnit = $this.data('unit');
        $('.toggle-conversion-btn').removeClass('active btn btn-primary').addClass('btn btn-tertiary');
        $this.addClass('active btn btn-primary').removeClass('btn btn-tertiary');

        if (selectedUnit === 'cm') {
            $('.unit.cm').removeClass('d-none');
            $('.unit.in').addClass('d-none');
        } else {
            $('.unit.in').removeClass('d-none');
            $('.unit.cm').addClass('d-none');
        }
    });
};

const handleSelectionForPenStrokeSizeChart = function () {
    $(document).on('click', '.pen-stroke-guide .card', function () {
        $('.pen-stroke-guide .card').removeClass('selected');
        $(this).addClass('selected');
    });
};

module.exports = {
    unitConversion,
    handleSelectionForPenStrokeSizeChart,
};
